import { render, staticRenderFns } from "./IconUserAddOutline.vue?vue&type=template&id=cc46df7e"
import script from "./IconUserAddOutline.vue?vue&type=script&lang=js"
export * from "./IconUserAddOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports